import { render, staticRenderFns } from "./NodeEdit.vue?vue&type=template&id=64b7bec4&scoped=true"
import script from "./NodeEdit.vue?vue&type=script&lang=js"
export * from "./NodeEdit.vue?vue&type=script&lang=js"
import style0 from "./NodeEdit.vue?vue&type=style&index=0&id=64b7bec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7bec4",
  null
  
)

export default component.exports